/* eslint-disable */

// if (process.env.NODE_ENV !== 'production'){
//   document.addEventListener('contextmenu', (e) => {
//     e.preventDefault()
//   })
// }
// var log = Function.prototype.bind.call(console.log, console)

setTimeout(console.log.bind(console, '%c Created By Controlla %c %c 1.0.0 ', 'background: #111; color: #fff', 'background: #7fbcc6; color: #fff', 'background: #ecaa2e; color: #fff'));
var i = "Stop!",
     j = "Si estas aqui intentando copiar algo de código podrias estar cometiendo algun delito."

if ((window.chrome || window.safari)) {
var l = 'font-family:helvetica; font-size:20px; ';
[
[i, l + 'font-size:50px; font-weight:bold; ' + 'color:red; -webkit-text-stroke:1px black;'],
[j, l],
['', '']
].map(function(r) {
 setTimeout(console.log.bind(console, '\n%c' + r[0], r[1]))
})
}

// console.log(`%c
//
//    ▄████▄  ▒█████   ███▄    █ ▄▄▄█████▓ ██▀███   ▒█████   ██▓     ██▓    ▄▄▄
//   ▒██▀ ▀█ ▒██▒  ██▒ ██ ▀█   █ ▓  ██▒ ▓▒▓██ ▒ ██▒▒██▒  ██▒▓██▒    ▓██▒   ▒████▄
//   ▒▓█    ▄▒██░  ██▒▓██  ▀█ ██▒▒ ▓██░ ▒░▓██ ░▄█ ▒▒██░  ██▒▒██░    ▒██░   ▒██  ▀█▄
//   ▒▓▓▄ ▄██▒██   ██░▓██▒  ▐▌██▒░ ▓██▓ ░ ▒██▀▀█▄  ▒██   ██░▒██░    ▒██░   ░██▄▄▄▄██
//   ▒ ▓███▀ ░ ████▓▒░▒██░   ▓██░  ▒██▒ ░ ░██▓ ▒██▒░ ████▓▒░░██████▒░██████▒▓█   ▓██▒
//   ░ ░▒ ▒  ░ ▒░▒░▒░ ░ ▒░   ▒ ▒   ▒ ░░   ░ ▒▓ ░▒▓░░ ▒░▒░▒░ ░ ▒░▓  ░░ ▒░▓  ░▒▒   ▓▒█░
//     ░  ▒    ░ ▒ ▒░ ░ ░░   ░ ▒░    ░      ░▒ ░ ▒░  ░ ▒ ▒░ ░ ░ ▒  ░░ ░ ▒  ░ ▒   ▒▒ ░
//   ░       ░ ░ ░ ▒     ░   ░ ░   ░        ░░   ░ ░ ░ ░ ▒    ░ ░     ░ ░    ░   ▒
//   ░ ░         ░ ░           ░             ░         ░ ░      ░  ░    ░  ░     ░  ░
//   ░
//
// `, 'background: #fff; color: red')
